/**
 * @generated SignedSource<<f0fe1a4283ec3216e0228279fe31b9ed>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type async_softwareReleasesLaunchCard_LaunchCard$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ui_softwareReleasesLaunchCard_LaunchCard">;
  readonly " $fragmentType": "async_softwareReleasesLaunchCard_LaunchCard";
};
export type async_softwareReleasesLaunchCard_LaunchCard$key = {
  readonly " $data"?: async_softwareReleasesLaunchCard_LaunchCard$data;
  readonly " $fragmentSpreads": FragmentRefs<"async_softwareReleasesLaunchCard_LaunchCard">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "async_softwareReleasesLaunchCard_LaunchCard",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "ui_softwareReleasesLaunchCard_LaunchCard"
    }
  ],
  "type": "JiraVersion"
};

(node as any).hash = "ed744d145282aafc0de30b038a930975";

export default node;
